import { observable, runInAction } from 'mobx';
import { InsuranceCompany } from './insurancesApi';
import controller from './controller';

export interface InsurancesCompaniesStore {
  insuranceCompanies: InsuranceCompany[],
  loading: boolean,
  error: string,
}

const initialValues: InsurancesCompaniesStore = {
  insuranceCompanies: [],
  loading: false,
  error: null,
};

export const insurancesCompaniesStore = observable(initialValues);

export const insurancesCompaniesActions = {
  getCompanies: async () => {
    runInAction(() => {
      insurancesCompaniesStore.loading = true;
    });
    
    try {
      // Страховые компании редко меняются, поэтому не имеет смысла повторять запросы
      if (insurancesCompaniesStore.insuranceCompanies.length>0) { return; }
      const response = await controller.getInsuranceCompanies();
      insurancesCompaniesStore.insuranceCompanies = response.data;
      insurancesCompaniesStore.loading = false;
    } catch (err) {
      insurancesCompaniesStore.loading = false;
      insurancesCompaniesStore.error = err.message || err;
    }
  },
};
